import { format } from '@/libs/util.number.js'

export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
    fixed: 'left',
  },
  {
    field: 'col-opt',
    title: that.$l('table_label_operation') || '操作',
    width: 70,
    fixed: 'left',
    align: 'center',
    slots: { default: 'opt' },
    visible: !that.disabled,
  },
  {
    title: that.$l('table_label_quantity') || '不良品数量',
    field: 'quantity',
    align: 'center',
    minWidth: 80,
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => format(cellValue),
  },
  {
    title: that.$l('table_label_issuesTitle') || '不良原因',
    field: 'issuesTitle',
    align: 'center',
    minWidth: 180,
    showHeaderOverflow: true,
  },
]
